'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import logoGrayPrimary from '../../public/images/hive-logo-gray.png';
import logoWhitePrimary from '../../public/images/hive-logo-white.png';
import { useAppContext } from '@/app/_lib/_context';
export default function SiteBranding() {
  const $ = _c(13);
  const pathname = usePathname();
  const {
    closeMobileMenu
  } = useAppContext();
  const isHome = pathname === "/";
  if (isHome || pathname === "/hive-trade-program") {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="hidden group-[.collapsed]/header:block lg:!hidden"><FontAwesomeIcon icon={faHiveIconSmallLight} aria-hidden="true" className="text-primary text-4xl" /></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    const t1 = `w-[100px] h-[50px] block md:hidden group-[.opaque]/header:!hidden group-[.collapsed]/header:!hidden${isHome ? " landscape:hidden" : ""}`;
    let t2;
    if ($[1] !== t1) {
      t2 = <Image priority={true} className={t1} src={logoWhitePrimary} quality={90} sizes="(max-width: 1023px) 88px, 90px" alt="hive - Modern Design for the Home" />;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const t3 = `w-[100px] h-[50px] hidden group-[.opaque]/header:block md:block group-[.collapsed]/header:!hidden lg:group-[.collapsed]/header:!block${isHome ? " landscape:block" : ""}`;
    let t4;
    if ($[3] !== t3) {
      t4 = <Image priority={true} className={t3} src={logoGrayPrimary} quality={90} sizes="(max-width: 1023px) 88px, 90px" alt="hive - Modern Design for the Home" />;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== closeMobileMenu || $[6] !== t2 || $[7] !== t4) {
      t5 = <Link aria-label="hive - home" className="shrink-0 z-10 relative block lg:mb-4" href="/" onClick={closeMobileMenu}>{t0}{t2}{t4}</Link>;
      $[5] = closeMobileMenu;
      $[6] = t2;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t0;
  let t1;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hidden group-[.collapsed]/header:block lg:!hidden"><FontAwesomeIcon icon={faHiveIconSmallLight} aria-hidden="true" className="text-primary text-4xl" /></div>;
    t1 = <Image priority={true} className="w-[100px] h-[50px] block group-[.collapsed]/header:!hidden lg:group-[.collapsed]/header:!block" src={logoGrayPrimary} quality={90} sizes="(max-width: 1023px) 88px, 90px" alt="hive - Modern Design for the Home" />;
    $[9] = t0;
    $[10] = t1;
  } else {
    t0 = $[9];
    t1 = $[10];
  }
  let t2;
  if ($[11] !== closeMobileMenu) {
    t2 = <Link aria-label="hive - home" className="shrink-0 z-10 block lg:mb-4" href="/" onClick={closeMobileMenu}>{t0}{t1}</Link>;
    $[11] = closeMobileMenu;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}